import { render } from "./payment-type-icon.vue?vue&type=template&id=70f21f4c"
import script from "./payment-type-icon.vue?vue&type=script&lang=js"
export * from "./payment-type-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__